import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem, EuiSteps } from "@elastic/eui";
import React from "react";

import * as S from "../../style";

import { getCurrentPointId } from "../../utils";

const generateSteps = (tripPoints, currentTripPointId, tripStatus) => {
    const currentPointId = getCurrentPointId(tripPoints, currentTripPointId, tripStatus);
    let isCurrentTripFound = false;

    return tripPoints.map((point) => {
        const title = point.locationAttributes
            ? point.locationAttributes.data.attributes.nameAr ||
              point.locationAttributes.data.attributes.nameEn ||
              point.locationAttributes.data.attributes.name ||
              `${point.locationAttributes.data.attributes.address} ${point.locationAttributes.data.id}` ||
              point.locationAttributes.data.attributes.address
            : point.cityName;
        const status = currentPointId && !isCurrentTripFound ? "complete" : null;

        const step = {
            title,
            children: title,
            status,
            color: "#fff",
            onClick: () => {},
        };

        if (+point.id === currentPointId) {
            isCurrentTripFound = true;
        }

        return step;
    });
};

function DropOffDetailsOverlay({ tripPoints, currentTripPointId, onHide, tripStatus }) {
    return (
        <S.StyledOverlayMask onClick={onHide}>
            <S.DropOffDetailsOverlayWrapper>
                <EuiFlexGroup
                    responsive={false}
                    alignItems="center"
                    gutterSize="none"
                    className="dropOffDetailsOverlay__header"
                >
                    <EuiFlexItem>
                        <h3>
                            <b>{`Trip #${tripPoints[0].tripId} Points`}</b>
                        </h3>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        <EuiButtonIcon
                            onClick={onHide}
                            iconType="cross"
                            color="danger"
                            iconSize="l"
                            aria-label="close"
                        />
                    </EuiFlexItem>
                </EuiFlexGroup>

                <S.TripStepDetails>
                    <EuiSteps steps={generateSteps(tripPoints, currentTripPointId, tripStatus)} />
                </S.TripStepDetails>
            </S.DropOffDetailsOverlayWrapper>
        </S.StyledOverlayMask>
    );
}

export default DropOffDetailsOverlay;
